import {match, Pattern} from 'ts-pattern';

import type {OnlineOfferEngagementScrollDepth} from '@dms/api/sales';
import i18n from '@dms/i18n';

const SCROLL_DEPTH_NONE = 0;
const SCROLL_DEPTH_QUARTER = 25;
const SCROLL_DEPTH_HALF = 50;
const SCROLL_DEPTH_THREE_QUARTERS = 75;
const SCROLL_DEPTH_BOTTOM = 100;

const SCROLLED_TO_BOTTOM_KEY = 'page.businessCase.labels.onlineOfferEngagement.scrolledToBottom';
const SCROLLED_TO_DEPTH_KEY = 'page.businessCase.labels.onlineOfferEngagement.scrolledToDepth';

/**
 * Describes how far the customer scrolled through the online offer.
 * Returns null when the customer never scrolled, so callers can omit the segment.
 */
export const getEngagementScrollSegment = (maxScrollDepth: OnlineOfferEngagementScrollDepth) =>
  match(maxScrollDepth)
    .with(SCROLL_DEPTH_BOTTOM, () => i18n.t(SCROLLED_TO_BOTTOM_KEY))
    .with(
      Pattern.union(SCROLL_DEPTH_QUARTER, SCROLL_DEPTH_HALF, SCROLL_DEPTH_THREE_QUARTERS),
      (depth) => i18n.t(SCROLLED_TO_DEPTH_KEY, {depth})
    )
    .with(SCROLL_DEPTH_NONE, () => null)
    .exhaustive();
